@if (show) {
  <div>
    @if (piData) {
      <form [formGroup]="otherNameform" (ngSubmit)="onSubmit()">
        <!-- show horizonally -->
        <div class="flex-wrapper">
          <div class="fx-flex-40">
            <div class="is-taller">
              <div class="level">
                <div class="level-item">
                  <h2 class="bofa--heading is-6">Enter your other name(s)</h2>
                </div>
              </div>
            </div>
            @for (otherForm of otherNameList.controls; track otherForm; let i = $index) {
              <div [formGroup]="otherForm">
                <div>
                  @if (step === i) {
                    <mat-accordion>
                      <mat-expansion-panel [class.border]="border" [expanded]="step === i" [hideToggle]="true"
                        (opened)="setStep(i)" class="af-mat-card mat-elevation-z">
                        <mat-expansion-panel-header class="mat-expansion outlined">
                          <mat-panel-title>
                            Name {{i+1}}
                          </mat-panel-title>
                          <mat-panel-description>
                            <div tabindex="0" (keyup.enter)="deleteClick(i)" (click)="deleteClick(i)">
                              <svg class="height-Width_20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="remove other name">
                                <g data-name="24 x 24 BOX">
                                  <rect fill="none" width="24" height="24"/>
                                </g>
                                <g data-name="ICON OUTLINE">
                                <polygon fill="#e31837" class="cls-2" points="21 3.707 20.293 3 12 11.293 3.707 3 3 3.707 11.293 12 3 20.293 3.707 21 12 12.707 20.293 21 21 20.293 12.707 12 21 3.707"/></g>
                              </svg>
                            </div>
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <!-- set focus when pressing Add button -->
                        <div tabindex="-1" #addElement class="bofa--skiplink"></div>
                        <mat-form-field class="max-width minor-list-space"
                          hideRequiredMarker>
                          <mat-label><abbr title='required'>* </abbr>Name type</mat-label>
                          <mat-select formControlName="nameType" required>
                            <mat-option>Select</mat-option>
                            @for (nameType of piData.nameTypeLookup | keyvalue : valueAscOrder; track nameType) {
                              <mat-option
                                [value]="nameType.key">
                                {{nameType.value}}
                              </mat-option>
                            }
                          </mat-select>
                          <mat-hint class="bofa--skiplink">{{ dropDownScreenReaderNameType(otherForm) }}</mat-hint>
                          @if (otherForm.controls.nameType.hasError('required') ) {
                            <mat-error>Please select Name type
                            </mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="max-width minor-list-space"
                          hideRequiredMarker>
                          <mat-label><abbr title='required'>* </abbr>First name</mat-label>
                          <input matInput formControlName="otherFirstName" required maxlength="100">
                          <mat-error>Please enter valid First name</mat-error>
                        </mat-form-field>
                        <div>
                          <mat-form-field class="max-width">
                            <mat-label>Middle name (optional)</mat-label>
                            <input matInput formControlName="otherMiddleName" maxlength="100">
                            <mat-error>Please enter valid Middle name</mat-error>
                          </mat-form-field>
                        </div>
                        <mat-form-field class="max-width minor-list-space"
                          hideRequiredMarker>
                          <mat-label><abbr title='required'>* </abbr>Last name</mat-label>
                          <input matInput formControlName="otherLastName" required maxlength="100">
                          <mat-error>Please enter valid Last name</mat-error>
                        </mat-form-field>
                        @if (piData.jobCountryValue !== 'India') {
                          <mat-form-field class="max-width" hideRequiredMarker>
                            <mat-label><abbr title='required'>* </abbr>Date of name change</mat-label>
                            <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                              formControlName="dateNameChange" required maxlength="100">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-hint>Format mm/dd/yyyy</mat-hint>
                            @if (otherForm.controls.dateNameChange.errors) {
                              <mat-error>Please enter date of name change in the
                                format mm/dd/yyyy
                              </mat-error>
                            }
                          </mat-form-field>
                        }
                        @if (piData.jobCountryValue === 'India') {
                          <mat-form-field class="max-width">
                            <mat-label>Date of name change</mat-label>
                            <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                              formControlName="dateNameChange" maxlength="100">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-hint>Format mm/dd/yyyy</mat-hint>
                            @if (otherForm.controls.dateNameChange.errors) {
                              <mat-error>Please enter date of name change in the
                                format mm/dd/yyyy
                              </mat-error>
                            }
                          </mat-form-field>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  }
                </div>
              </div>
            }
          </div>
          <div class="fx-flex-60">
            <div>
              <div class="is-taller">
                <div class="level">
                  <div>
                    <h2 id="reviewList" class="bofa--heading is-6 flex-heading">Review your
                    other name(s)</h2>
                  </div>
                  <div> <button #addButtonElement [disabled]="otherNameform.invalid"
                    type="button" class="bofa--button secondary" (click)="onAddOtherName()">Add
                  Name</button>
                </div>
              </div>
            </div>
            @if (listCheck) {
              <mat-selection-list aria-describedby="reviewList"
                (selectionChange)="handleSelection($event)">
                @for (otherForm of otherNameList.controls; track otherForm; let i = $index) {
                  <mat-list-option [value]="i"
                    [selected]="step === i" (keyup.enter)="focusTarget()">
                    <div class="is-taller">
                      <div class="level">
                        <div class="level-item">
                          @if ( !otherForm.invalid) {
                            <label>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="check completed name" class="review-icon">
                                <g data-name="24 x 24 BOX">
                                  <rect fill="none" width="24" height="24"/>
                                </g>
                                <g data-name="ICON OUTLINE">
                                  <polygon fill="#012169" points="20.216 4 9.781 18.466 3.731 12.475 3.027 13.186 9.908 20 21.027 4.586 20.216 4"/>
                                </g>
                              </svg>
                            </label>
                          }
                          @if ( otherForm.invalid) {
                            <label>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="error incomplete name">
                                <path fill="#e31837" d="M12,2.52,2.52,21.48H21.48Zm0,2.236L19.862,20.48H4.138Z"/>
                                <rect fill="none" width="24" height="24"/>
                              </svg>
                            </label>
                          }
                          <span class="padd-left-10">{{i+1}}</span>
                        </div>
                        <div class="level-item level-overflow">
                          {{otherForm.controls.otherFirstName.value}}
                          {{otherForm.controls.otherMiddleName.value }} {{otherForm.controls.otherLastName.value }}
                        </div>
                        <div class="level-item padd-left-10">
                          {{otherForm.controls.dateNameChange.value | dateFormat }}
                        </div>
                      </div>
                    </div>
                    <mat-divider aria-hidden="true"></mat-divider>
                  </mat-list-option>
                }
              </mat-selection-list>
            }
          </div>
        </div>
      </div>
    </form>
  }
</div>
}
